<script lang="ts">
	import { Button, ButtonSize, ButtonType } from '@repo/commons/components'
	import { chatT } from '@repo/commons/i18n/chat'

	interface Props {
		onConfirm?: () => void
		onCancel: () => void
	}

	let { onConfirm, onCancel }: Props = $props()
</script>

<div class="description">
	{$chatT('NewChat.Modal.Text')}
</div>

<div class="actions">
	<Button
		buttonType={ButtonType.BRAND}
		buttonSize={ButtonSize.MEDIUM}
		buttonText={$chatT('NewChat.Modal.Buttons.Confirm')}
		onclick={onConfirm}
	/>
	<Button
		buttonType={ButtonType.INVERSE_OUTLINE}
		buttonSize={ButtonSize.MEDIUM}
		buttonText={$chatT('Button.Cancel')}
		onclick={onCancel}
	/>
</div>

<style lang="postcss">
	.actions {
		@apply flex justify-between flex-col gap-4 w-full mt-6;
	}
	:global(.actions .button-class) {
		@apply flex-1 border-[#007acc];
	}

	:global(.actions .inverse-outline .button-text) {
		@apply text-[#007acc];
	}
</style>
